import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import { useHistory } from "react-router-dom";
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';

import { getNewsItems } from '../../actions/news-actions'
import Loading from '../shared/Loading'
import NewsHolder from './NewsHolder'
import LatestNewsHolder from './LatestNewsHolder'
import TopNewsHolder from './TopNewsHolder'
import { BreadcrumbsCustom } from '../shared/component'

import useStyles from '../../styles/components/news/stylesNews'

const News = () => {
    const history = useHistory();
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [newsFilter, setNewsFilter] = React.useState({});
    const [data, setData] = useState({
        page: 1,
        size: 5
    })

    useEffect(() => {
        initNewsItems();
    }, [data])

    const initNewsItems = async () => {
        const response = await getNewsItems(data);
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        setNewsFilter(response.data)
        setLoading(false);
    }

    const breadcrumbsData = [
        {
            type: 'Survey',
            text: 'News',
            href: ''
        },
    ];

    const handlePageChange = (event, value) => setData({
        ...data,
        page: value
    })

    if (loading) return <Loading />;

    return (
        <>
            <Grid container justify="center" direction="column" alignItems="center">
                <Grid item xs={3} />
                <Grid container direction="column" item xs={12} sm={12} md={9} lg={6} classes={{ root: classes.rootGridContain }}>
                    <Grid container alignItems="center" classes={{ root: classes.rootGridBreadcrumbs }}>
                        <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
                        <ChevronRightRoundedIcon />
                    </Grid>
                    <Typography classes={{ root: classes.rootTypography }}>Latest News</Typography>
                    {newsFilter && Object.keys(newsFilter).length !== 0 ?
                        <LatestNewsHolder news={newsFilter.top1NewsViewModel} />
                        :
                        <div style={{ textAlign: 'center' }}>
                            Nothing found!
                        </div>
                    }
                    <Grid container justify="space-between" direction="row" alignItems="center" spacing={1}>
                        {newsFilter && newsFilter?.top4NewsViewModel?.length !== 0 && newsFilter?.top4NewsViewModel?.map(item =>
                            <TopNewsHolder key={item.id} news={item} />
                        )}
                    </Grid>
                    <Typography classes={{ root: classes.rootTypography }}>Other News</Typography>

                    <Grid container>
                        {newsFilter && Object.keys(newsFilter).length !== 0 && newsFilter?.otherNewsViewModel?.data?.length !== 0 ? newsFilter?.otherNewsViewModel?.data?.map(item =>
                            <NewsHolder key={item.id} news={item} />
                        )
                            :
                            <div style={{ margin: 'auto' }}>Nothing found!</div>}
                    </Grid>
                    <Grid container style={{ margin: "20px 0" }}
                        direction={'row'}
                        alignContent={'center'}
                        justify={'center'}
                    >
                        {newsFilter?.otherNewsViewModel?.data && newsFilter?.otherNewsViewModel?.data?.length !== 0 &&
                            <Pagination count={Math.ceil(newsFilter.otherNewsViewModel.pageTotal)}
                                variant="outlined"
                                shape="rounded"
                                color="secondary"
                                page={newsFilter.otherNewsViewModel.page}
                                onChange={handlePageChange}
                                classes={{ ul: classes.pagination }}
                            />
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default News;